exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pager__item[data-v-bdefb6aa]{display:inline-block;transition:all .5s}.list-enter[data-v-bdefb6aa],.list-leave-to[data-v-bdefb6aa]{opacity:0;transform:translateY(30px)}.list-leave-active[data-v-bdefb6aa]{position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader!./node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.2_mtgpqfwjwwc4gzzdhxqqjlkm5m/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdefb6aa","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/sass-loader@6.0.7_node-sass@4.14.1_webpack@3.12.0/node_modules/sass-loader/lib/loader.js!./node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.2_mtgpqfwjwwc4gzzdhxqqjlkm5m/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pager.vue
// module id = 375
// module chunks = 0